
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class ColorQualityMappingGrid extends Serenity.EntityGrid<ColorQualityMappingRow, any> {
        protected getColumnsKey() { return 'OMS.ColorQualityMapping'; }
        protected getDialogType() { return ColorQualityMappingDialog; }
        protected getIdProperty() { return ColorQualityMappingRow.idProperty; }
        protected getInsertPermission() { return ColorQualityMappingRow.insertPermission; }
        protected getLocalTextPrefix() { return ColorQualityMappingRow.localTextPrefix; }
        protected getService() { return ColorQualityMappingService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}